import type { Reducer } from 'redux';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { PII_CONSISTENCY_FAILURE, PII_CONSISTENCY_REQUEST, PII_CONSISTENCY_SUCCESS } from '../actionTypes/complianceActionTypes';
import type {
    PIIConsistencyCheckState,
    PIIConsistencyApiResponse,
    PIIConsistencyResponse,
    PIIConsistencyErrorResponse
} from '@makemydeal/dr-dash-types';

export const PIIConsistencyInitialState: PIIConsistencyCheckState = {
    checkPIILoading: false,
    checkPIIResponse: {},
    checkPIIError: null,
    piiConsistency: {},
    getPIILoading: false,
    getPIIResponse: {},
    getPIIError: null
};

export type PIIConsistencyReducer = Reducer<PIIConsistencyCheckState>;

export const reducer: Reducer<PIIConsistencyCheckState> = (
    state: PIIConsistencyCheckState = PIIConsistencyInitialState,
    action: AnyFSA
) => {
    switch (action.type) {
        case PII_CONSISTENCY_REQUEST:
            return {
                ...state,
                getPIILoading: true,
                getPIIError: null
            };
        case PII_CONSISTENCY_SUCCESS: {
            const response = action.payload as PIIConsistencyResponse;

            // Handle null/undefined response first
            if (!response) {
                return {
                    ...state,
                    getPIILoading: false,
                    getPIIError: 'Invalid response - no data received'
                };
            }

            // Check if this is an error response with ok: false
            if (!response.ok) {
                const errorResponse = response as PIIConsistencyErrorResponse;
                return {
                    ...state,
                    getPIILoading: false,
                    getPIIError: errorResponse.error?.rawError || errorResponse.message || 'Unknown error occurred'
                };
            }

            // Handle successful response
            const successResponse = response as PIIConsistencyApiResponse;
            const piiData = successResponse.data?.checkResult?.checkResult;

            if (!piiData) {
                return {
                    ...state,
                    getPIILoading: false,
                    getPIIError: 'Invalid response structure - no PII data found'
                };
            }

            return {
                ...state,
                getPIILoading: false,
                getPIIResponse: piiData,
                getPIIError: null
            };
        }
        case PII_CONSISTENCY_FAILURE:
            return {
                ...state,
                getPIILoading: false,
                getPIIError: action.payload?.message || action.payload || 'Failed to fetch PII consistency data'
            };
        default:
            return state;
    }
};
